import { TLAtoms } from '@/components/design-system/atoms'
import { TLMolecules } from '@/components/design-system/molecules'

export const TL = {
  ...TLAtoms,
  ...TLMolecules
}
